import { Flex } from '@assets/component/UI/Flex/Flex';
import * as style from './PanelHeader.module.less';
export const PanelHeader = (props: { title: string; iconUrl?: string }) => {
    var icon = <i className="bi bi-clipboard"></i>;
    if (props.iconUrl) {
        icon = <img src={props.iconUrl} alt="icon" />;
    }
    return (
        <Flex className={style.panelRowHeader}>
            {icon}
            <div className="flex-grow-1">{props.title}</div>
            <div></div>
        </Flex>
    );
};
